import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardWithNotesFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.75 1.5a.75.75 0 0 1 .75.75v.278h2.75V2.25a.75.75 0 0 1 1.5 0v.278h2.75V2.25a.75.75 0 0 1 1.5 0v.286a3.75 3.75 0 0 1 3.5 3.742V17.75a3.75 3.75 0 0 1-3.75 3.75h-9.5a3.75 3.75 0 0 1-3.75-3.75V6.278A3.75 3.75 0 0 1 7 2.536V2.25a.75.75 0 0 1 .75-.75M8 9.75A.75.75 0 0 1 8.75 9h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 8 9.75m0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClipboardWithNotesFilled);
export default ForwardRef;
